<template>
    <span class="artist" v-if="simpleText">{{artistString === "" ? "No artist":artistString}}</span>
    <span v-else-if="displayBagdes" class="artist-badge-container" @click.prevent="onClick">
        <span v-if="artists != null" v-for="artist in sortedArtists" :key="artist.name" :class="['badge', 'artist-badge',{hidden:!artist.isVisible}]">
            <span class="visible"><i :class="['far', artist.isVisible?'fa-eye':'fa-eye-slash']"></i></span>
            <span class="name">{{artist.name}}</span>
            <!--<span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleArtist(artist)"></i>
            </span>-->
        </span>
        <span v-if="artists !=null && !showHidden"><i class="far fa-eye-slash">&nbsp;{{hiddenArtists.length}}</i></span>
    </span>
    <input v-else type="text" readonly :placeholder="!!artistOnly ? artistOnly : 'Artist'" :value="artistString" :class="!artistString || artistString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
        name: "ArtistBadgeList",
        props: {
            artists: [Array, String],
            showHidden: { type: Boolean, default: false },
            displayBagdes: { type: Boolean, default: false },
            simpleText: { type: Boolean, default: false },
            artistOnly: {type: String, required: false}
        },
        computed: {
            hiddenArtists() {
                if (this.artists === null) return [];
                return this.artists && this.artists.filter(art => !art.isVisible);
            },
            visibleArtists() {
                if (this.artists === null) return [];
                return this.artists && this.artists.filter(art => art.isVisible);
            },
            sortedArtists() {
                let tmpList = this.artists && this.artists;
                if (this.artists === null) return [];

                if (!this.showHidden) {
                    tmpList = this.visibleArtists || [];
                }


                return tmpList.sort(function (a, b) {
                    if (a.isVisible === b.isVisible) {
                        if (a.displayOrder === b.displayOrder) return 0;
                        if (a.displayOrder > b.displayOrder) return 1;
                        return -1;
                    }
                    return a.isVisible ? -1 : 1;
                });

                // return sortedArtists;
            },
            artistString() {
                const artNames = this.sortedArtists.map(x =>  x.name);
                const hidden = this.hiddenArtists || [];
                return artNames.join(' - ') + (!this.showHidden || hidden.length === 0 ? "" : (" (linked : " + hidden.map(x => x.name).join(" - ") +")"));
            }
        },
         methods: {
            onClick(event) { this.$emit("click", event); }
        }
    }
</script>

<style scoped>
    .artist-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .artist-badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .artist-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .artist-badge.hidden {
        background: #d2d2d2;
    }

    .artist-badge .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

    input [type=text]:focus {
        background: transparent;
    }
</style>
